/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Device_Name_Too_LongInputs */

const vi_error_irrigation_device_name_too_long = /** @type {(inputs: Error_Irrigation_Device_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên trạm tối đa 120 ký tự.`)
};

/**

* @param {Error_Irrigation_Device_Name_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_device_name_too_long = /** @type {((inputs?: Error_Irrigation_Device_Name_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Device_Name_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_device_name_too_long(inputs)
});